import React from "react"
import { Field } from "react-final-form"

import { Grid } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { isNilOrEmpty } from "ramda-extension"

import { FilterGroup } from "./layout"
import { Combobox } from "../../../molecules"

const useStyles = makeStyles(({ typography }) => ({
  autocompleteFilter: {
    "& .MuiAutocomplete-tag": {
      height: "28px",
      lineHeight: "28px",
    },

    "& .MuiChip-deleteIcon": {
      fontSize: "18px !important",
    },

    "& .MuiChip-root": {
      // @TODO uncomment it when tooltip will available for chips
      // "& > span.MuiChip-label": {
      //   maxWidth: "194px",
      //   overflow: "hidden",
      //   textOverflow: "ellipsis",
      //   whiteSpace: "nowrap",
      // },

      background: "transparent",
      border: "solid rgba(0,0,0, .26)",
    },

    "& .MuiInputLabel-root": {
      fontSize: typography.pxToRem(14),
      lineHeight: typography.pxToRem(24),
    },

    "& .MuiFilledInput-root": {
      "& .MuiAutocomplete-tag": {
        marginTop: "0",
      },
      "& input": {
        paddingTop: "4px !important",
        width: "fit-content",
      },
      display: "flex",
      flexWrap: "wrap",
      maxWidth: "fit-content",
      minHeight: "56px !important",
      minWidth: "100%",
      paddingTop: "19px !important",
    },

    background: "white",
  },
}))

export const AutocompleteFilter = ({
  autoComplete = true,
  blurOnSelect = false,
  disableCloseOnSelect = true,
  limitTags = 10,
  multiple,
  name,
  onInputChange,
  optionLabel,
  options,
  renderOption,
  title,
}) => {
  const { autocompleteFilter } = useStyles()

  return (
    <FilterGroup xs={12}>
      <Grid container justifyContent="start" spacing={1} className={autocompleteFilter}>
        <Grid item xs={12}>
          <Field name={name}>
            {(field) => (
              <Combobox
                {...field}
                blurOnSelect={blurOnSelect}
                disableCloseOnSelect={disableCloseOnSelect}
                autoComplete={autoComplete}
                forcePopupIcon={true}
                triggerLength={0}
                value={
                  isNilOrEmpty(field.input.value)
                    ? []
                    : multiple
                    ? field.input.value
                    : [field.input.value]
                }
                onChange={(_, value) => {
                  onInputChange && onInputChange("")

                  if (multiple) {
                    const uniqueValues = value.reduce((result, valueItem) => {
                      return result
                        .filter((item) => {
                          if (item.id) return item.id !== valueItem.id
                          if (item.value) return item.value !== valueItem.value
                        })
                        .concat(valueItem)
                    }, [])

                    field.input.onChange((uniqueValues.length > 0 && uniqueValues) || undefined)
                    return
                  }

                  field.input.onChange(value[1] || value[0] || "")
                }}
                onInputChange={(event) => onInputChange && onInputChange(event.target.value)}
                InputProps={{
                  disableUnderline: true,
                }}
                label={title}
                optionLabel={optionLabel}
                renderOption={renderOption}
                fullWidth
                options={options}
                multiple
                variant="filled"
                type="date"
                width="100%"
                limitTags={limitTags}
                style={{ marginBottom: "16px" }}
              />
            )}
          </Field>
        </Grid>
      </Grid>
    </FilterGroup>
  )
}
